import { ProviderContext } from 'notistack';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Toast } from 'src/components/Toast';
import { useElectronUpdateStatus } from 'src/features/electron/ElectronUpdateContext';
import { getElectronAPI } from 'src/hooks/useElectron';

export const useElectronUpdates = (
  enqueueSnackbar: ProviderContext['enqueueSnackbar'],
) => {
  const { t } = useTranslation();
  const { status } = useElectronUpdateStatus();
  const prevStatusRef = React.useRef(status);

  React.useEffect(() => {
    const prev = prevStatusRef.current;
    prevStatusRef.current = status;

    if (status === 'ready' && prev !== 'ready') {
      const api = getElectronAPI();
      enqueueSnackbar('Update ready', {
        persist: true,
        content: (key: string) => (
          <div key={key}>
            <Toast
              variant="info"
              title={t(($) => $.desktop_app.update_toast.title)}
              description={t(($) => $.desktop_app.update_toast.description)}
              actionProps={{
                onClick: () => api?.installUpdate(),
                children: t(($) => $.desktop_app.update_toast.restart_now),
                className: 'text-base',
              }}
            />
          </div>
        ),
      });
    }
  }, [status, enqueueSnackbar, t]);
};
